export default function recentTrip ({ origin, destination }) {
  return `<div class="autocomplete-item suggestions-item">
    <p class="place-info">
      <b>${origin.cityName}</b>
      ${origin.display}
    </p>
    <p class="place-info">
      <b>${destination.cityName}</b>
      ${destination.display}
    </p>
  </div>`;
}
